import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import ViewMoreArticlesFunc from "./viewMoreArticles";

function fmtDate(d) {
  try {
    const date = typeof d === "string" ? new Date(d) : d;
    if (!date || isNaN(date)) return null;
    return date.toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
  } catch {
    return null;
  }
}

const Article = ({ title, content, viewMoreArticles = [], updatedAt, createdAt }) => {
  const dateLabel = useMemo(() => fmtDate(updatedAt) || fmtDate(createdAt), [updatedAt, createdAt]);

  return (
    <section>
      <div className="p-8 lg:py-16 lg:px-48">
        {/* Breadcrumb / back */}
        <div className="mb-4">
          <Link to="/nyheter" className="text-sm text-blue-600 hover:underline">
            ← Tillbaka till Nyheter
          </Link>
        </div>

        <h2 className="text-2xl font-bold mb-2">{title}</h2>
        {dateLabel && <div className="text-sm text-gray-500 mb-4">{dateLabel}</div>}

        <div
          className="prose max-w-none"
          // content is sanitized server-side; render as HTML
          dangerouslySetInnerHTML={{ __html: content || "<p><em>Inget innehåll tillgängligt.</em></p>" }}
        />
      </div>

      {Array.isArray(viewMoreArticles) && viewMoreArticles.length > 0 && (
        <ViewMoreArticlesFunc viewMoreArticles={viewMoreArticles} />
      )}
    </section>
  );
};

export default Article;
